import Signup from './signup.vue'

export default {
  name: 'signup',
  path: '/accounts/signup',
  component: Signup,
  meta: {
    secure: false,
    reCaptcha: true
  }
}